import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/flp/experiments';
import useEventExperiments from '~/hooks/common/telemetry/useEventExperiments';

export default function useSetDataDogContext() {
  useEventExperiments(browserCookieIdExperiments, userIdExperiments);
}
